// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BtlG","newExpiryDate":"styles_newExpiryDate__2sFUd","footer":"styles_footer__3ZhV1"};